import type { AfterViewInit, ElementRef } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, ViewChild } from '@angular/core';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirToolbarComponent } from '../toolbar/toolbar.component';

@Component({
  selector: 'palantir-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  standalone: true,
  imports: [PalantirContentComponent, PalantirToolbarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirListItemComponent implements AfterViewInit {
  @ViewChild('children') public children?: ElementRef<HTMLElement>;

  @Input() public active?: boolean = false;

  @Input() public disabled?: boolean = false;

  public ngAfterViewInit() {
    const children = Array.from(
      this.children?.nativeElement.querySelectorAll(
        'palantir-list-item',
      ) as unknown as HTMLCollectionOf<HTMLElement>,
    );
    if (children.length <= 1) return;

    for (const element of children) {
      let height = 0;

      if (element.previousElementSibling?.tagName === 'PALANTIR-LIST-ITEM') {
        height = element.previousElementSibling?.clientHeight;
      } else {
        const parent = element.parentElement;
        if (!parent) continue;

        const previousElement = parent?.previousSibling as HTMLElement;
        if (!previousElement) continue;

        const previousElementChildren = Array.from(
          (previousElement as HTMLElement)?.getElementsByTagName(
            'palantir-list-item',
          ) as HTMLCollectionOf<HTMLElement>,
        );

        height = previousElementChildren[0]?.clientHeight || 0;
      }

      if (!height) continue;

      const listItem = Array.from(
        element.querySelectorAll('.palantir-list-item') as unknown as HTMLCollectionOf<HTMLElement>,
      )[0];
      if (!listItem) continue;

      listItem.style.setProperty('--palantir-list-item-after-size', `${height}px`);
      listItem.style.setProperty('--palantir-list-item-after-content', `''`);
    }
  }
}
